import { useEffect } from "react";

export const useOnClickOutside = (refs: any[], handler: any) => {
  useEffect(() => {
    const listener = (event: any) => {
      let outside = true;

      refs.forEach((ref: any) => {
        if (!ref.current || ref.current.contains(event.target)) {
          outside = false;
        }
      });

      if (!outside) return;

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [refs, handler]);
};
